import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

/* ---------------- Live announcer (route titles, timers, sync status) ---------------- */

const AnnounceContext = createContext<((message: string) => void) | null>(null);

export function LiveAnnouncer({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState('');
  const announce = useCallback((m: string) => {
    // Clear first so repeating the same message is announced again.
    setMessage('');
    queueMicrotask(() => setMessage(m));
  }, []);
  return (
    <AnnounceContext value={announce}>
      {children}
      <div className="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
        {message}
      </div>
    </AnnounceContext>
  );
}

export function useAnnounce(): (message: string) => void {
  return useContext(AnnounceContext) ?? (() => {});
}

